module.exports = __webpack_public_path__ + "fonts/IstokWeb-Regular.d13f14e4.woff";